import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useTalononeDisablePromoCode, useTalononePromoResponse } from '@/hooks/talonone';
import { TalononeDisablePromoCodeModal } from '@/types/modal';
import { ErrorModal, StandardModal, SuccessModal } from '@/components/molecules/common/Modal';
import styles from './Modal.module.scss';

const View: React.FC<{ modal: TalononeDisablePromoCodeModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { client, promo, onClose, page, pageSize } = modal;

  const { refetch } = useTalononePromoResponse(client.clientId, page, pageSize, true);

  const submitR = useTalononeDisablePromoCode();

  useEffect(() => {
    if (submitR.kind === 'Completed') {
      refetch();
    }
  }, [submitR.kind]);

  if (submitR.kind === 'Error') {
    return (
      <ErrorModal
        title={t('modal.talonone_disable.title')}
        error={submitR.error}
        onClose={onClose}
      />
    );
  } else if (submitR.kind === 'Completed') {
    return (
      <SuccessModal
        title={t('modal.talonone_disable.title')}
        onClose={onClose}
      />
    );
  }

  const body = (
    <div className={styles.flex100}>
      <div className={styles.height05rem} />
      <div className={styles.text1rem}>
        <Trans
          i18nKey="modal.talonone_disable.body"
          values={{
            code: promo.code,
            email: client.email,
          }}
        />
      </div>
      <div className={styles.height1rem} />
    </div>
  );

  return (
    <StandardModal
      title={t('modal.talonone_disable.title')}
      onClose={onClose}
      onSubmit={() =>
        submitR.mutate({
          campaignId: promo.campaign.id,
          couponId: promo.code,
          clientId: client.clientId,
        })
      }
      submittable={submitR.kind !== 'Loading'}
      submitLabel={t('common.confirm').toUpperCase()}
      body={body}
      containerStyle={{ maxWidth: 500 }}
      modalName="talonone_disable"
    />
  );
};

export default View;
